import * as Sentry from "@sentry/react";

export interface SentryBreadcrumb extends Sentry.Breadcrumb {}

class SentryUtils {
  captureException(section: string, error: Error) {
    Sentry.captureException(error, {
      level: "error",
      extra: {
        section,
      },
    });
  }

  captureBreadcrumb({
    category,
    message,
    level,
  }: SentryBreadcrumb) {
    Sentry.addBreadcrumb({
      category,
      message,
      level,
    });
  }
}

export default new SentryUtils();
